import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  makeStyles,
  Typography,
  Grid,
  FormHelperText,
  Table,
  TableHead,
  TableRow,
  TableCell,
  withStyles,
  TableBody,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TablePagination,
  TextField,
  TableFooter,
} from "@material-ui/core/";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import Alert from "../../../components/Ui/Alert";
import Aux from "../../../hoc/Auxilliary";
import {
  getTerms,
  getClasses,
  clearErrorStatusCode as attendanceClearErrorStatusCode,
  clearErrorMessage as attendanceClearErrorMessage,
} from "../../../reduxSlices/attendaceSlice";
import {
  getTest,
  deleteTest,
  getTestEditEligibility,
  getTeststudentList,
  patchTeststudentList,
  patchTestDetails,
  getGradeGroup,
  removeGradeGroup,
  removeStudentList,
  clearErrorStatusCode,
  clearErrorMessage,
  createTest,
} from "../../../reduxSlices/testSlice";
import Backdrop from "../../Backdrop";
import MessageIndicator from "../../SnackBar";
import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import localizedStrings from "../../../utils/localize";
import { getOptionList } from "../../../reduxSlices/applicationSlice";
const useStyle = makeStyles((theme) => ({
  heading: {
    fontSize: "1.8rem",
    fontWeight: 500,
  },
  formDesignMain: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    minHeight: "60vh",
    marginTop: "1rem",
  },
  formDesign: {
    width: "97%",
    margin: "0 auto",
  },
  formControl: {
    margin: theme.spacing(1),
    maxWidth: "30%",
  },
  DialogFormControl: {
    margin: theme.spacing(1),
    maxWidth: "100%",
    display: "flex",
  },
  formControl2: {
    margin: theme.spacing(1),
    width: "61%",
  },
  selectFormControl: {
    maxWidth: "100%",
    display: "flex",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const defaultTestData = {
  ses_pointspossible: "",
  ses_percentoffinalgrade: "",
  _ses_term_value: "",
  _ses_classid_value: "",
  _ses_gradegroupid_value: "",
  ses_testtype: "",
  ses_testsubject: "",
  ses_testdate: moment().format("YYYY-MM-DD"),
};

const TestAndScore = (props) => {
  const dispatch = useDispatch();
  const classes = useStyle(props);
  const [term, setTerms] = useState(0);
  const [className, setClassName] = useState(0);
  const [testsData, setTestsData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedTest, setSelectedTest] = useState({ test: "", id: "" });
  const [refresh, setRefresh] = useState({ loading: false, done: false });
  const [page, setPage] = useState(0);
  const [studentPage, setStudentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [studentRowsPerPage, setStudentRowsPerPage] = useState(5);
  const [maxLimit, setMaxLimit] = useState(false);
  const [saveTest, setSaveTest] = useState(false);
  const [saveStudent, setSaveStudent] = useState(false);
  const [gradeGroup, setGradeGroup] = useState([]);
  const [testCreate, setTestCreate] = useState(defaultTestData);
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [testTypes, settestTypes] = useState([]);
  const [displayMessage,setDisplayMessage]=useState('')
  const [students, setStudents] = useState([]);
  const [testClass, setTestClass] = useState({ ses_testtype: "" });
  const [isTestOpen, setIsTestOpen] = useState(false);
  const termsData = useSelector((state) => state.attendanceData.term);
  const classNameData = useSelector((state) => state.attendanceData.className);
  const testData = useSelector((state) => state.testData.test);
  const applicantData = useSelector(
    (state) => state.applicationData.applicantStatus.ses_applicantstatus
  );
  const eligibility = useSelector((state) => state.testData.eligibility);
  const studentList = useSelector((state) => state.testData.studentList);
  const gradeGroupData = useSelector((state) => state.testData.gradeGroup);
  const dataFetchingStatus1 = useSelector(
    (state) => state.attendanceData.dataFetchingStatus
  );
  const errorMessage1 = useSelector(
    (state) => state.attendanceData.errorMessage
  );
  const errorStatusCode1 = useSelector(
    (state) => state.attendanceData.errorStatusCode
  );
  const dataFetchingStatus2 = useSelector(
    (state) => state.testData.dataFetchingStatus
  );
  const errorMessage2 = useSelector((state) => state.testData.errorMessage);
  const errorStatusCode2 = useSelector(
    (state) => state.testData.errorStatusCode
  );
  const dataFetchingStatus = dataFetchingStatus1 || dataFetchingStatus2;
  const errorMessage = errorMessage1 || errorMessage2;
  const errorStatusCode = errorStatusCode1 || errorStatusCode2;
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleChange = (event) => {
    if (event.target.value) {
      if (event.target.name === "term") {
        setClassName(0);
        setTerms(event.target.value);
      } else if (event.target.name === "className") {
        setClassName(event.target.value);
      }
    }
  };
  const optionList = useSelector((state) => state.applicationData.optionList);
 
  useEffect(() => {
    let entity = "ses_test";
    let attributename = "ses_testtype";
    dispatch(getOptionList(entity, attributename));
  }, []);


  useEffect(()=>{
    if(optionList?.length != 0){
      settestTypes(optionList)
    }
  },[optionList])

  useEffect(() => {
    if (!isObjectEmpty(eligibility)) {
      setSaveTest(eligibility.editTest);
      setSaveStudent(eligibility.editScore);
    }
  }, [eligibility]);
  useEffect(() => {
    if(applicantData){
      dispatch(getTerms(
        {  applicantId: applicantData.ses_applicantid,
          type: "testsAndScores",}
      ));
    }

  }, [applicantData]);
  useEffect(() => {
    if (term !== 0) {
      dispatch(
        getClasses({
          query: "className",
          applicantId: applicantData.ses_applicantid,
          termId: term,
          type: "testsAndScores",
        })
      );
    }
  }, [term]);
  useEffect(() => {
    if (className !== 0) {
      dispatch(getTest(className));
    }
  }, [className]);
  useEffect(() => {
    setTestsData(testData);
  }, [testData]);
  useEffect(() => {
    if (gradeGroupData.length > 0) {
      setGradeGroup(gradeGroupData);
    }
  }, [gradeGroupData]);

  useEffect(() => {
    if (isTestOpen) {
      const classData = classNameData.find(
        (data) => data.ses_classid === className
      );
      setTestCreate((prev) => ({
        ...prev,
        _ses_term_value: term,
        _ses_classid_value: className,
        ses_classname: classData.ses_classname,
      }));
      dispatch(getGradeGroup());
    } else if (!isTestOpen && gradeGroupData.length > 0) {
      dispatch(removeGradeGroup());
      setTestCreate(defaultTestData);
    }
  }, [isTestOpen]);
  useEffect(() => {
    if (refresh.loading && !dataFetchingStatus) {
      setRefresh((prev) => ({ ...prev, done: true }));
    }
  }, [dataFetchingStatus]);
  useEffect(() => {
    if (refresh.loading && refresh.done) {
      dispatch(getTest(className));
      setRefresh({ loading: false, done: false });
    }
  }, [refresh]);
  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(attendanceClearErrorStatusCode());
    dispatch(attendanceClearErrorMessage());
    props.history.push("/login");
  };

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  useEffect(() => {
    if (studentList.length > 0) {
      setStudents(
        studentList.map((student) => {
          let ses_testscoredecimal = 0.0;
          if (typeof student.ses_testscoredecimal === "string") {
            ses_testscoredecimal =
              student.ses_testscoredecimal &&
              student.ses_testscoredecimal.length > 0
                ? student.ses_testscoredecimal.toFixed(2)
                : student.ses_testscoredecimal;
          } else {
            ses_testscoredecimal =
              student.ses_testscoredecimal > 0
                ? student.ses_testscoredecimal.toFixed(2)
                : student.ses_testscoredecimal;
          }
          return { ...student, ses_testscoredecimal };
        })
      );
    }
  }, [studentList]);
  const handleClickOpen = (index) => {
    index = rowsPerPage * page + index;
    setOpenDialog(true);
    setSelectedTest({
      test: testsData[index].ses_test,
      id: testsData[index].ses_testid,
    });
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedTest({ test: "", id: "" });
  };

  const handleDialogDelete = () => {
    setOpenDialog(false);
    dispatch(deleteTest(selectedTest.id));
    setTestsData(
      testsData.filter((data) => data.ses_testid !== selectedTest.id)
    );
    setSelectedTest({ test: "", id: "" });
  };
  const handleCreateTestDialogClose = () => {
    setTestCreate(defaultTestData);
    setIsTestOpen(false);
  };

  const handleEdit = (index) => {
    index = rowsPerPage * page + index;
    dispatch(
      getTestEditEligibility({
        classId: className,
        contactId: window.localStorage.getItem("x-auth-contactId"),
      })
    );
    dispatch(getTeststudentList({ testId: testsData[index].ses_testid }));
    const ses_pointspossible = testsData[index].ses_pointspossible
      ? testsData[index].ses_pointspossible.toFixed(2)
      : testsData[index].ses_pointspossible;
    setTestClass({ ...testsData[index], ses_pointspossible });
    setOpenEdit(true);
  };
  const handleEditClose = () => {
    setOpenEdit(false);
    setSaveStudent(false);
    setSaveTest(false);
    setTestClass({});
    setStudents([]);
    dispatch(removeStudentList());
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChangeStudentRowsPerPage = (event) => {
    setStudentRowsPerPage(+event.target.value);
    setStudentPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeStudentPage = (event, newPage) => {
    setStudentPage(newPage);
  };

  const handleStudentChanges = (event, index) => {
    event.persist();
    index = studentRowsPerPage * studentPage + index;
    setStudents((prev) => {
      const modified = [...prev];
      const student = { ...modified[index] };
      if (student.ses_testscoredecimal === 0 && event.target.value.length > 0) {
        student.ses_testscoredecimal = event.target.value.substr(
          1,
          event.target.value.length
        );
      } else {
        student.ses_testscoredecimal =
          event.target.value.length === 0 ? 0 : event.target.value;
      }
      modified[index] = student;
      return modified;
    });
  };
  const handleTestChanges = (event) => {
    event.persist();
    setTestClass((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };
  const handleDateChange = (date) => {
    setTestClass((prev) => ({ ...prev, ses_testdate: date }));
  };
  const onScoreSubmit = () => {
    const validate = students.findIndex(
      (student) =>
        student.ses_testscoredecimal.length > 0 &&
        !/^[1-9]\d*(\.\d+)?$/.test(student.ses_testscoredecimal)
    );
    if (validate === -1) {
      if (
        students.some(
          (student) =>
            student.ses_testscoredecimal * 1 > testClass.ses_pointspossible
        )
      ) {
        setMaxLimit(true);
      } else {
        dispatch(
          patchTeststudentList({
            testId: testClass.ses_testid,
            classId: className,
            data: students,
          })
        );
        handleEditClose();
      }
    } else {
      setStudents((prev) => {
        const modified = [...prev];
        modified[validate].validate = false;
        return modified;
      });
    }
  };
  const onTestSubmit = () => {
    setRefresh((prev) => ({ ...prev, loading: true }));
    const ses_percentoffinalgrade = testClass.ses_percentoffinalgrade
      ? parseFloat(testClass.ses_percentoffinalgrade).toFixed(2) * 1
      : "";
    dispatch(
      patchTestDetails({
        testId: testClass.ses_testid,
        ...testClass,
        ses_percentoffinalgrade,
      })
    );
    handleEditClose();
  };

  const handleWarningClose = () => {
    setMaxLimit(false);
  };
  const handleWarningSubmit = () => {
    dispatch(
      patchTeststudentList({
        testId: testClass.ses_testid,
        classId: className,
        data: students,
      })
    );
    handleEditClose();
    setMaxLimit(false);
  };

  const handleCreatetest = (event) => {
    event.persist();
    setTestCreate((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };
  const handleTestDateChange = (dateTime) => {
    setTestCreate((prev) => ({ ...prev, ses_testdate: dateTime }));
  };
  const handleTestCreateSubmit = () => {
    let isValidate = true;
    for (const key in testCreate) {
      if (key === "_ses_gradegroupid_value") continue;
      if (
        (typeof testCreate[key] === "string" &&
          testCreate[key].trim().length < 1) ||
        (key === "ses_pointspossible" &&
          !/^[1-9]\d*(\.\d+)?$/.test(testCreate[key])) ||
        (key === "ses_percentoffinalgrade" &&
          !/^[1-9]\d*(\.\d+)?$/.test(testCreate[key]))
      ) {
        isValidate = false;
        break;
      }
    }
    if (isValidate) {
      setRefresh((prev) => ({ ...prev, loading: true }));
      dispatch(
        createTest({
          ...testCreate,
          ses_pointspossible:
            parseFloat(testCreate.ses_pointspossible).toFixed(2) * 1,
          ses_percentoffinalgrade:
            parseFloat(testCreate.ses_percentoffinalgrade).toFixed(2) * 1,
        })
      );
      handleCreateTestDialogClose();
    } else {
      alert(`${localizedStrings.general.validInput}`);
    }
  };
  let tableData = `${localizedStrings.general.notestsavailable}`;

  if (testsData.length > 0) {
    tableData = testsData
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((test, index) => (
        <StyledTableRow key={index}>
          <StyledTableCell component="th" scope="row">
            {" "}
            {test.ses_testdate
              ? moment(test.ses_testdate).format("YYYY-MM-DD")
              : ""}{" "}
          </StyledTableCell>
          <StyledTableCell align="center">
            {" "}
            {test.ses_testsubject}{" "}
          </StyledTableCell>
          <StyledTableCell align="center">
            {" "}
            {
              test["ses_testtype@OData.Community.Display.V1.FormattedValue"]
            }{" "}
          </StyledTableCell>
          <StyledTableCell align="center">
            {" "}
            {
              test[
                "ses_percentoffinalgrade@OData.Community.Display.V1.FormattedValue"
              ]
            }{" "}
          </StyledTableCell>
          <StyledTableCell align="center">
            <IconButton
              color="primary"
              aria-label="edit"
              onClick={() => handleEdit(index)}
              component="span"
            >
              <EditIcon />
            </IconButton>
            <IconButton
              color="secondary"
              aria-label="delete"
              onClick={() => handleClickOpen(index)}
              component="span"
            >
              <DeleteIcon />
            </IconButton>
          </StyledTableCell>
        </StyledTableRow>
      ));
  }
  useEffect(() => {
    if (error.message === 'success') {
      setDisplayMessage(localizedStrings.general.success);
    }
   else if (error.message === 'Something Went Wrong') {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    }
   else if (error.message === 'successfully created') {
      setDisplayMessage(localizedStrings.general.successfullycreatedmsg);
    }
    else if (error.message === 'class id is required') {
      setDisplayMessage(localizedStrings.general.classiderrorMessage);
    }
    else if (error.message === 'Test id is required') {
      setDisplayMessage(localizedStrings.general.testiderrorMessage);
    }
    else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } 
    else if (error.message === "Invalid request") {
      setDisplayMessage(localizedStrings.general.invalidRequest);
    } 
    else{
      setDisplayMessage(error.message);
    }
  }, [error]);

   // Custom label for the "of" keyword in TablePagination
   const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };
  
  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Grid container item className={classes.formDesignMain}>
        <Typography component="div" className={classes.heading}>
          Tests & scores
        </Typography>
        <FormControl className={classes.formControl}>
          <InputLabel id="term">
            {localizedStrings.facultyAndStuff.attendance.term}
          </InputLabel>
          <Select
            labelId="term"
            id="term"
            value={term}
            name="term"
            onChange={handleChange}
            disabled={!applicantData}
          >
            <MenuItem value={0}>
              <em>{localizedStrings.facultyAndStuff.attendance.selectOne} </em>
            </MenuItem>
            {termsData.length > 0
              ? termsData.map((el, index) => (
                  <MenuItem value={el.ses_termid} key={index}>
                    {el.ses_termname}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
        {term !== 0 ? (
          <Grid container justify="space-between">
            <Grid xs={6} item>
              <FormControl className={classes.formControl2}>
                <InputLabel id="className">
                  {localizedStrings.facultyAndStuff.attendance.className}{" "}
                </InputLabel>
                <Select
                  labelId="className"
                  id="className"
                  value={className}
                  name="className"
                  onChange={handleChange}
                >
                  <MenuItem value={0}>
                    <em>
                      {localizedStrings.facultyAndStuff.attendance.selectOne}
                    </em>
                  </MenuItem>
                  {classNameData.length > 0 ? (
                    classNameData.map((classData, index) => (
                      <MenuItem value={classData.ses_classid} key={index}>
                        {classData.ses_coursename}
                      </MenuItem>
                    ))
                  ) : (
                    <FormHelperText>
                      {
                        localizedStrings.facultyAndStuff.attendance
                          .NoClassNameMsg
                      }{" "}
                    </FormHelperText>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              {className !== 0 ? (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setIsTestOpen(true)}
                >
                  Create Test
                </Button>
              ) : null}
            </Grid>
          </Grid>
        ) : null}
        {className !== 0 ? (
          <>
            <TableContainer
              component={Paper}
              style={{ minHeight: "40vh", marginBottom: "10px" }}
            >
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">Date</StyledTableCell>
                    <StyledTableCell align="center"> {localizedStrings.facultyAndStuff.testScore.subject}</StyledTableCell>
                    <StyledTableCell align="center">Type</StyledTableCell>
                    <StyledTableCell align="center">
                      % of Final Grade
                    </StyledTableCell>
                    <StyledTableCell align="center">Actions</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{tableData}</TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={testsData.length > 0 ? testsData.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={<span style={{textTransform:"none"}}>{localizedStrings.rows.rowsperpage}</span>}
                labelDisplayedRows={customLabelDisplayedRows}
              />
            </TableContainer>
          </>
        ) : null}
      </Grid>

      <div>
        <Alert
          isOpen={openDialog}
          title={"Confirmation"}
          onClose={handleDialogClose}
          actions={
            <>
              <Button onClick={handleDialogDelete} color="primary">
                Ok
              </Button>
              <Button onClick={handleDialogClose} color="primary">
                Cancel
              </Button>
            </>
          }
        >
          Are you sure that you want to delete test {selectedTest.test}
        </Alert>
      </div>
      <div>
        <Dialog
          onBackdropClick={handleEditClose}
          onClose={handleEditClose}
          aria-labelledby="customized-dialog-title"
          open={openEdit}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
            Edit Test
          </DialogTitle>
          <DialogContent dividers>
            <Backdrop show={dataFetchingStatus} />
            <Grid wrap="wrap" container spacing={3}>
              <Grid xs={6} item>
                <TextField
                  onChange={handleTestChanges}
                  fullWidth
                  id="title"
                  label="Title"
                  name="ses_test"
                  value={testClass.ses_test}
                />
              </Grid>
              <Grid xs={6} item>
                <FormControl className={classes.DialogFormControl}>
                  <InputLabel id="demo-simple-select-label">type</InputLabel>
                  <Select
                    autoWidth
                    value={testClass.ses_testtype}
                    onChange={handleTestChanges}
                    name="ses_testtype"
                  >
                    
                    {testTypes?.length != 0 && Object.keys(testTypes)?.length != 0 && testTypes.map((type) => {
                      return (
                        <MenuItem value={type.attributevalue} key={type.attributevalue}>
                          {type.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={6} item>
                <TextField
                  onChange={handleTestChanges}
                  id="Subject"
                  value={testClass.ses_testsubject}
                  name="ses_testsubject"
                  fullWidth
                  label={localizedStrings.facultyAndStuff.testScore.subject}
                />
              </Grid>
              <Grid xs={6} item>
                <TextField
                  onChange={handleTestChanges}
                  id="finalgrade"
                  value={testClass.ses_percentoffinalgrade}
                  name="ses_percentoffinalgrade"
                  fullWidth
                  label="% Final Grade "
                />
              </Grid>
              <Grid xs={6} item>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    format="yyyy-MM-dd"
                    margin="normal"
                    id="date-picker-inline"
                    label="Date picker inline"
                    value={testClass.ses_testdate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid xs={6} item>
                <TextField
                  id="max"
                  fullWidth
                  label="Maximum Points Available"
                  name="ses_pointspossible"
                  onChange={handleTestChanges}
                  value={testClass.ses_pointspossible}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-end"
              alignItems="flex-end"
              style={{ textAlign: "right" }}
            >
              <Grid xs item>
                <Button
                  onClick={onTestSubmit}
                  color="primary"
                  disabled={!saveTest}
                  variant="contained"
                >
                  Save Information
                </Button>
              </Grid>
            </Grid>
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <TableContainer component={Paper} style={{ marginTop: "30px" }}>
                  <Table aria-label="student score">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">
                          Student Name
                        </StyledTableCell>
                        <StyledTableCell align="center">Score</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {students
                        .slice(
                          studentPage * studentRowsPerPage,
                          studentPage * studentRowsPerPage + studentRowsPerPage
                        )
                        .map((student, index) => {
                          return (
                            <TableRow key={index}>
                              <StyledTableCell align="center">
                                {student.ses_studentname1}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <TextField
                                  value={student.ses_testscoredecimal}
                                  helperText={
                                    student.validate === undefined
                                      ? false
                                      : !student.validate
                                      ? `${localizedStrings.general.validInput}`
                                      : ""
                                  }
                                  error={
                                    student.validate === undefined
                                      ? false
                                      : !student.validate
                                  }
                                  style={{ width: "30%" }}
                                  onChange={(event) =>
                                    handleStudentChanges(event, index)
                                  }
                                  fullWidth
                                />
                              </StyledTableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={students.length > 0 ? students.length : 0}
                    rowsPerPage={studentRowsPerPage}
                    page={studentPage}
                    onChangePage={handleChangeStudentPage}
                    onChangeRowsPerPage={handleChangeStudentRowsPerPage}
                    labelRowsPerPage={<span style={{textTransform:"none"}}>{localizedStrings.rows.rowsperpage}</span>}
                    labelDisplayedRows={customLabelDisplayedRows}
                  />
                  <TableFooter></TableFooter>
                </TableContainer>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-end"
              alignItems="flex-end"
              spacing={3}
              style={{ textAlign: "right" }}
            >
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleEditClose}
                  color="secondary"
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={onScoreSubmit}
                  disabled={!saveStudent}
                  color="primary"
                >
                  Save
                </Button>
              </Grid>
            </Grid>

            <div>
              <Alert
                title="Warning"
                isOpen={maxLimit}
                onClose={handleWarningClose}
                actions={
                  <>
                    <Button onClick={handleWarningSubmit} color="primary">
                      Ok
                    </Button>
                    <Button onClick={handleWarningClose} color="primary">
                      Cancel
                    </Button>
                  </>
                }
              >
                {localizedStrings.general.savegradesmsg}
              </Alert>
            </div>
          </DialogContent>
        </Dialog>
      </div>
      <Alert
        title="Create Test"
        isOpen={isTestOpen}
        onClose={handleCreateTestDialogClose}
        actions={
          <>
            <Button onClick={handleTestCreateSubmit} color="primary">
              Submit
            </Button>
            <Button onClick={handleCreateTestDialogClose} color="primary">
              Cancel
            </Button>
          </>
        }
      >
        <Grid container direction="column">
          <Backdrop show={dataFetchingStatus} />
          <Grid item>
            <TextField
              id="term"
              fullWidth
              label="Term"
              disabled
              value={
                termsData.length > 0 && term !== 0
                  ? termsData.find((termData) => termData.ses_termid === term)
                      .ses_termname
                  : ""
              }
            />
          </Grid>
          <Grid item>
            <TextField
              id="class"
              fullWidth
              label={localizedStrings.facultyAndStuff.class.class}
              disabled
              value={
                className !== 0
                  ? classNameData.find(
                      (classData) => classData.ses_classid === className
                    ).ses_coursename
                  : ""
              }
            />
          </Grid>
          <Grid item>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                variant="inline"
                format="yyyy-MM-dd"
                margin="normal"
                id="testDate"
                label="Test Date*"
                value={testCreate.ses_testdate}
                onChange={handleTestDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item>
            <TextField
              id="max"
              fullWidth
              label="Test Subject"
              required
              onChange={handleCreatetest}
              value={testCreate.ses_testsubject}
              name="ses_testsubject"
            />
          </Grid>
          <Grid item>
            <FormControl className={classes.selectFormControl}>
              <InputLabel id="gradeGroup">Grade Group</InputLabel>
              <Select
                autoWidth
                name="_ses_gradegroupid_value"
                onChange={handleCreatetest}
                value={testCreate._ses_gradegroupid_value}
              >
                {gradeGroup.map((grade) => (
                  <MenuItem
                    value={grade.ses_gradegroupid}
                    key={grade.ses_gradegroupid}
                  >
                    {grade.ses_gradegroup}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl className={classes.selectFormControl}>
              <InputLabel id="testtpe">Test Type*</InputLabel>
              <Select
                autoWidth
                name="ses_testtype"
                onChange={handleCreatetest}
                value={testCreate.ses_testtype}
              >
                {testTypes?.length != 0 && Object.keys(testTypes)?.length != 0 && testTypes.map((type) => {
                  return (
                    <MenuItem value={type.attributevalue} key={type.attributevalue}>
                      {type.value}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <TextField
              id="finalgrade"
              fullWidth
              label="% of final grade"
              onChange={handleCreatetest}
              required
              value={testCreate.ses_percentoffinalgrade}
              name="ses_percentoffinalgrade"
            />
          </Grid>
          <Grid item>
            <TextField
              id="class"
              fullWidth
              label="Point Possible"
              onChange={handleCreatetest}
              required
              value={testCreate.ses_pointspossible}
              name="ses_pointspossible"
            />
          </Grid>
        </Grid>
      </Alert>
    </Aux>
  );
};

export default withRouter(TestAndScore);
